import { useEffect } from "react";
import { APP_GTM_KEY } from "@config/gtm";

const useGoogleTagManagerScript = () => {
  const gtmKey = APP_GTM_KEY;

  useEffect(() => {
    if (!gtmKey) {
      return;
    }

    const startComment = document.createComment("Google Tag Manager");

    const script = document.createElement("script");
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-${gtmKey}');`;

    const endComment = document.createComment("End Google Tag Manager");

    document.head.appendChild(startComment);
    document.head.appendChild(script);
    document.head.appendChild(endComment);

    const scriptBody = document.createElement("noscript");
    scriptBody.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-${gtmKey}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

    document.body.prepend(startComment);
    document.body.prepend(scriptBody);
    document.body.prepend(endComment);

    return () => {
      if (!gtmKey) {
        return;
      }
      document.head.removeChild(startComment);
      document.head.removeChild(script);
      document.head.removeChild(endComment);

      document.body.removeChild(startComment);
      document.body.removeChild(scriptBody);
      document.body.removeChild(endComment);
    };
  }, []);
};

export default useGoogleTagManagerScript;
